<script lang="ts">
    import { get } from 'svelte/store';

    import { creditCardLoginTrackBids } from '../../constants/loginTrackBids';
    import { isJumpOneLink, isLogin, PhoneCell } from '../../store/index';
    import {
        ensurePassportSdk,
        normalizePassportLoginData
    } from '../../utils/passport';
    import { trackEvent } from '../../utils/track';

    import FifaLoginFlow from '@/components/fifaLogin/FifaLoginFlow.svelte';

    const getRegisterExposeAttrs = () => ({
        is_login: get(isLogin) ? 1 : 0
    });

</script>

<FifaLoginFlow
    bids={creditCardLoginTrackBids}
    trackEvent={(eventId, attrs) => trackEvent(eventId, attrs)}
    phoneCellStore={PhoneCell}
    {isJumpOneLink}
    {getRegisterExposeAttrs}
    {ensurePassportSdk}
    {normalizePassportLoginData}
/>
